import clsx from 'clsx'

import { ColProperty, ColConfig, ColProps } from './col.types'

const constructBreakpointsClasses = (breakpoints: Record<string, ColProperty | undefined>) => {
  const keys = Object.keys(breakpoints)

  const classes = keys.reduce((previousClass, key) => {
    const breakpoint = key === 'xs' ? '' : `-${key}`
    const breakpointValue = breakpoints[key]

    if (breakpointValue) {
      if (typeof breakpointValue === 'number') {
        return clsx(previousClass, `hot-col${breakpoint}-${breakpointValue}`)
      }

      const { size, offset, order } = breakpointValue as ColConfig

      return clsx(previousClass, `hot-col${breakpoint}-${size}`, {
        [`hot-col${breakpoint}-offset-${offset}`]: offset,
        [`hot-col${breakpoint}-order-${order}`]: order
      })
    }

    return previousClass
  }, '')

  return classes || 'hot-col'
}

const Col = ({
  lg,
  md,
  sm,
  xl,
  xs,
  xxl,
  children,
  className,
  id = '',
  'data-test': dataTest
}: ColProps) => {
  const breakpoints = { xs, sm, md, lg, xl, xxl }
  const breakpointClasses = constructBreakpointsClasses(breakpoints)
  const classes = clsx(breakpointClasses, className)

  return (
    <div data-test={dataTest} id={id} className={classes}>
      {children}
    </div>
  )
}

export default Col
